var path = 'app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/targetTracking/targetTrackingPopover.html';
var html = "<target-tracking-chart config=\"$ctrl.policy.targetTrackingConfiguration\"\n                       state=\"$ctrl.state\"\n                       server-group=\"$ctrl.serverGroup\"></target-tracking-chart>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/targetTracking/targetTrackingPopover.html
// module id = 1177
// module chunks = 0